import { Row, Col } from "reactstrap";
import QuoteOverviewGeneralContractTable from "./quoteOverviewGeneralContractTable";
import QuoteOverviewGeneralSalesforceTable from "./quoteOverviewGeneralSalesforceTable";
import QuoteOverviewGeneralYearlyBreakdownTable from "./quoteOverviewGeneralYearlyBreakdown";

const QuoteOverviewGeneral = ({quoteItems, setExportData, isVisible}) => {

    if (!isVisible) {
        return null;
    }

    return (
        <>
        <Row className="mb-3">
            <Col xs="auto">
                <QuoteOverviewGeneralContractTable quoteItems={quoteItems} setExportData={setExportData} />
            </Col>
            <Col xs="auto">
                <QuoteOverviewGeneralSalesforceTable quoteItems={quoteItems} setExportData={setExportData} />
            </Col>
            <Col xs="auto">
                <QuoteOverviewGeneralYearlyBreakdownTable quoteItems={quoteItems} setExportData={setExportData} />
            </Col>
        </Row>
        </>
    );
}

export default QuoteOverviewGeneral;